import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../shared.module";
import { QuestionTemplatesModule } from "./question_templates/question_templates.module";

import { NzAvatarModule } from "ng-zorro-antd/avatar";
import { NzBadgeModule } from "ng-zorro-antd/badge";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzListModule } from "ng-zorro-antd/list";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzAlertModule } from "ng-zorro-antd/alert";
import { NzMessageModule } from "ng-zorro-antd/message";

import { HeaderComponent } from "./header/header.component";
import { SideNavComponent } from "./side_nav/side_nav.component";

import { ThemeConstantService } from "../services/theme_constant.service";

const antdModule = [
  NzAvatarModule,
  NzBadgeModule,
  NzDropDownModule,
  NzListModule,
  NzDividerModule,
  NzButtonModule,
  NzModalModule,
  NzToolTipModule,
  NzFormModule,
  NzInputModule,
  NzAlertModule,
  NzMessageModule,
];

@NgModule({
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HeaderComponent,
    SideNavComponent,
    QuestionTemplatesModule,
    ...antdModule,
  ],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    QuestionTemplatesModule,
    ...antdModule,
  ],
  declarations: [
    HeaderComponent,
    SideNavComponent,
  ],
  providers: [ThemeConstantService],
})
export class TemplateModule {}
